var mentions_default = {
  "mentionPalette": "ljL9g",
  "mention": "G0inp",
  "mentionViewer": "UUja7",
  "mentionSuggestionsEntry": "xQdcA",
  "mentionSuggestionsEntryFocused": "MvMP4",
  "mentionSuggestionsEntryText": "_2NJN3",
  "mentionSuggestionsEntryAvatar": "NuNIj",
  "mentionSuggestions": "nTOs1",
  "cursorDefault": "uB67m",
  "cursorPointer": "S4ani"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
